@if (isAuthenticated() && !standalonePage()) {
  @if (designToggle.version() === 'v2') {
    <!-- v2 redesign shell — config-driven sidebar + topbar with timer/notifs/new -->
    <app-shell-v2></app-shell-v2>
  } @else {
    <div class="app-shell" [class.nav-open]="mobileNavOpen">
      <app-nav></app-nav>
      <!-- Mobile overlay -->
      <div class="mobile-overlay" (click)="closeMobileNav()"></div>
      <div class="shell-body">
        <!-- Mobile top bar -->
        <div class="mobile-topbar">
          <button class="hamburger-btn" (click)="toggleMobileNav()" aria-label="Menu">
            <span></span><span></span><span></span>
          </button>
          <img [src]="themeService.isDark() ? 'assets/EZatwork.logo.1.2.png' : 'assets/blue-logo-trnsprnt-bg.png'"
               alt="EZ@Work" class="mobile-logo">
        </div>
        <app-announcement-banner></app-announcement-banner>
        <app-grace-period-banner></app-grace-period-banner>
        <main class="shell-content">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
  }
} @else {
  <router-outlet></router-outlet>
}

@if (!pipTimerSvc.isPipActive() && designToggle.version() !== 'v2') {
  <app-floating-timer></app-floating-timer>
}
<app-tour-overlay></app-tour-overlay>
<app-floating-notes></app-floating-notes>
@if (isAuthenticated() && !standalonePage()) {
  <app-assistant-launcher></app-assistant-launcher>
}
<app-toast></app-toast>
<app-cookie-consent-banner></app-cookie-consent-banner>
@if (isAuthenticated()) {
  <app-offline-banner></app-offline-banner>
}
